import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import api, { formatINR } from "@/lib/api";
import { useNavigate } from "react-router-dom";

export default function DSADashboard() {
  const [m, setM] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/dashboard/dsa").then(r => setM(r.data));
  }, []);
  return (
    <div data-testid="dsa-dashboard">
      <div className="flex justify-between items-start mb-6">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">DSA Dashboard</h1>
          <p className="text-sm text-slate-600 mt-1">Track your leads, conversions and commissions.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => navigate("/dsa/applications")}>View applications</Button>
          <Button className="bg-teal-600 hover:bg-teal-700" onClick={() => navigate("/dsa/new")} data-testid="dsa-new-lead-btn">Create lead</Button>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card className="p-5 border-slate-200" data-testid="dsa-kpi-leads"><div className="text-xs uppercase tracking-wider text-slate-500">Leads</div><div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{m?.leads ?? "—"}</div></Card>
        <Card className="p-5 border-slate-200" data-testid="dsa-kpi-approved"><div className="text-xs uppercase tracking-wider text-slate-500">Approved</div><div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{m?.approved ?? "—"}</div></Card>
        <Card className="p-5 border-slate-200" data-testid="dsa-kpi-disbursed"><div className="text-xs uppercase tracking-wider text-slate-500">Disbursed</div><div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{m?.disbursed ?? "—"}</div></Card>
        <Card className="p-5 border-slate-200" data-testid="dsa-kpi-rejected"><div className="text-xs uppercase tracking-wider text-slate-500">Rejected</div><div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{m?.rejected ?? "—"}</div></Card>
        <Card className="p-5 border-teal-200 bg-teal-50 md:col-span-2" data-testid="dsa-commission-earned">
          <div className="text-xs uppercase tracking-wider text-teal-700 font-semibold">Commission earned</div>
          <div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{formatINR(m?.commission_earned)}</div>
        </Card>
        <Card className="p-5 border-slate-200 md:col-span-2" data-testid="dsa-commission-pending">
          <div className="text-xs uppercase tracking-wider text-slate-500">Commission pending</div>
          <div className="text-3xl font-semibold text-slate-900 mt-1 font-mono">{formatINR(m?.commission_pending)}</div>
        </Card>
      </div>
    </div>
  );
}
